import React from 'react'
import {
  Datagrid,
  DateField,
  DateTimeInput,
  Filter,
  FilterProps,
  FunctionField,
  ListProps,
  Pagination,
  SelectInput,
  TextField,
  TextInput,
  useTranslate,
} from 'react-admin'
import { ResourceName } from '../../../core/ResourceName'
import List from '../../common/customized-ra-components/List'
import { SystemLogTypes } from '../../../core/enum/SystemLogTypes'
import { SystemLogDto } from '../../../core/dto/system-notifications/system-log.dto'
import { dateTimeInputDefaultParse } from '../../../core/common/date-time'

const ListFilters = (props: Omit<FilterProps, 'children'>) => (
  <Filter {...props}>
    <TextInput source="description" alwaysOn />
    <SelectInput
      source="type"
      choices={Object.values(SystemLogTypes).map((value) => ({
        id: value,
        name: `resources.enums.SystemLogTypes.${value}`,
      }))}
    />
    <DateTimeInput
      source="dateFrom"
      key="dateFrom"
      parse={dateTimeInputDefaultParse}
    />
    <DateTimeInput
      source="dateTo"
      key="dateTo"
      parse={dateTimeInputDefaultParse}
    />
  </Filter>
)

export const SystemLogsList = ({ ...props }: ListProps) => {
  const translate = useTranslate()

  return (
    <List
      {...props}
      exporter={false}
      filters={<ListFilters />}
      bulkActionButtons={false}
      perPage={20}
      pagination={<Pagination rowsPerPageOptions={[10, 20, 50, 100, 200]} />}
      sort={{
        field: 'id',
        order: 'DESC',
      }}
    >
      <Datagrid
        size="small"
        rowClick={(id) => `/${ResourceName.SYSTEM_LOGS}/${id}/show`}
      >
        <TextField source="id" label="ID" />
        <FunctionField<SystemLogDto>
          source="type"
          render={(record?: SystemLogDto) =>
            translate(`resources.enums.SystemLogTypes.${record?.type}`)
          }
        />
        <TextField source="description" />
        <DateField source="createdAt" showTime />
      </Datagrid>
    </List>
  )
}
